/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2020-05-12 16:09:00
 * @LastEditors: yy
 * @LastEditTime: 2021-05-26 16:48:59
 */

import registerCustom from './customNode'
import data from './index.json'

function deepObj(data, z) {
  const zIndex = z || 0
  data.zIndex = zIndex
  if (data.children && data.children.length > 0) {
    data.children.forEach(ele => {
      deepObj(ele, zIndex + 1)
    });
  }
}

function getColor(key) {
  const COLORS = {
    '微信号': '#5bbe26',
    '微博': '#fcc944',
    '知乎': '#0073dd',
  }
  return COLORS[key] || '#ff1111'
}


const main = async (dom) => {
  if (!global.document) return {}
  import(/* webpackChunkName: "G6RegisterNode" */ '@antv/g6').then(G6 => {
    // 注册
    registerCustom(G6)

    const graph = new G6.TreeGraph({
      container: dom,
      width: 1000,
      height: 700,
      pixelRatio: 2,
      linkCenter: true,
      modes: {
        default: [{
          type: 'collapse-expand',
          onChange: function onChange(item, collapsed) {
            const data = item.get('model').data;
            data.collapsed = collapsed;
            return true;
          }
        }, 'drag-canvas', 'zoom-canvas']
      },
      defaultNode: {
        size: 26,
        anchorPoints: [[0, 0.5], [1, 0.5]],
        style: {
          fill: '#C6E5FF',
          stroke: '#5B8FF9'
        }
      },
      defaultEdge: {
        style: {
          lineWidth: 2,
          stroke: '#e7e7e7',
        }
      },
  
      layout: {
        type: 'dendrogram',
        direction: 'H', // H / V / LR / RL / TB / BT
        // nodeSep: 40,
        // rankSep: 100,
        // radial: true
        nodeSep: 150
      }
    });
  
    graph.node(function (node) {
      if (!node.style) {
        node.style = {}
      }
  
      if (node.zIndex === 0) {
        // position = 'top'
        node.style.lineWidth = 0;
        node.style.stroke = '#ffd70d';
        node.style.fill = '#ffd70d';
        node.style.radius = 10;
  
        const nodeWidth = node.label.length * 16 + 30
        const w = nodeWidth > 180 ? nodeWidth : 180
        node.size = [w, 73]
        node.shape = 'rect'
      }
      if (node.zIndex === 1) {
        node.label = node.source_name
        node.style.lineWidth = 0;
        node.style.stroke = '#ffd70d';
        node.style.fill = '#ffd70d';
  
        node.size = [70, 70]
        node.shape = 'image'
        node.labelCfg = {
          position: 'bottom'
        }
        node.img = node.img_url
        node.clipCfg = {
          show: true,
          type: 'circle',
          r: 35
        }
      }
  
      if (node.zIndex === 2) {
        node.style.lineWidth = 1;
        node.style.stroke = '#ffd70d';
        node.style.fill = '#fff';
        node.style.radius = 10;
  
        node.size = [240, 120]
        node.shape = 'node-des'
        node.style.textAlign = 'left'
        node.color = getColor(node.plat)
      }
  
      return {
        labelCfg: {
          // position,
          // offset: 5,
          style: {
            // rotate,
            textAlign: 'center',
            fontSize: node.zIndex < 2 ? 18 : 16,
          }
        }
      };
    });
    graph.edge(edge => {
      const sourceModel = edge.source._cfg.model
      let dash = [0, 0]
      if (sourceModel.zIndex === 0) {
        dash = [8, 5]
      }
      return {
        style: {
          lineDash: dash,
          lineWidth: 2,
          stroke: '#e7e7e7',
        }
      }
    })
    // graph.addBehaviors('click-select', 'default');
    graph.on('click', (ev, ...arg) => {
      const item = ev.item || {}
      if (item._cfg && item._cfg.model) {
        const model = item._cfg.model
        if (model.zIndex === 2) {
          window.open(model.url)
        }
      }
    })
    deepObj(data)
    graph.data(data);
    graph.render();
    graph.fitView();
  })
}

export default main


// WEBPACK FOOTER //
// src/routes/customChart/KeyMediaGraph/chart.js